import React from "react";
import {StyleSheet, Text, View, ImageBackground, ScrollView, TouchableOpacity} from 'react-native';

import {RFValue} from "react-native-responsive-fontsize";

import { MaterialCommunityIcons } from '@expo/vector-icons';

import { Feather } from '@expo/vector-icons';
import { FontAwesome } from '@expo/vector-icons';

import { MaterialIcons } from '@expo/vector-icons';
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";

import { useNavigation , useFocusEffect} from '@react-navigation/native';
import Config from "../../components/Config";

const Wallet = ({navigation})=>{


    let [tab,setTab] = React.useState(1);

    let [profile,setProfile] = React.useState({
        reward : '0' ,
        walletAmount : '0',
        totalreward : '0',
        full_name : 'Loading ... ',
    });

    let [deposits,setDeposits] = React.useState([]);
    let [ws,setWs] = React.useState([]);


    React.useEffect(()=>{

    },[]);


    useFocusEffect(
        React.useCallback(() => {
            getData();
        }, [])
    );


    const getData = async ()=>{
        let token = await AsyncStorage.getItem('token');



        let res = await axios.get(
            `${Config.base}/api/v1/profile`,
            { params:
                    {
                        token: token
                    }
            }
        );
        profile = res.data;
        setProfile(res.data);


        let res2 = await axios.get(
            `${Config.base}/api/v1/payments/item`,
            { params:
                    {
                        token: token
                    }
            }
        );
        deposits = res2.data;
        setDeposits(res2.data);


        let res3 = await axios.get(
            `${Config.base}/api/v1/withdrawLists`,
            { params:
                    {
                        token: token
                    }
            }
        );
        ws = res3.data;
        setWs(res3.data);




    };



    return (
        <>
            <ImageBackground
                // source={require("https://metamax.network/public/appBg.jpg")}
                source={{uri:'https://metamax.network/public/appBg.jpg'}}
                // resizeMode="cover"
                // imageStyle={{
                //     borderBottomRightRadius : RFValue(15),
                //     borderBottomLeftRadius : RFValue(15),
                // }}

                style={{

                    paddingBottom : RFValue(20),
                }}

            >
                <View style={{flexDirection : 'row',justifyContent : 'space-between' , alignItems : 'center'}}>
                    <View>
                        <Text style={styles.headertext}>Main Wallet</Text>
                        <Text  style={styles.headername}>Hello , {profile.full_name}</Text>
                    </View>
                    <View style={styles.icon}>
                        <Feather onPress={()=>navigation.navigate('Profile')} name="user" size={24} color="#FFF" />
                    </View>
                </View>

                <View>
                    <View style={styles.bg2}>
                        <Text style={styles.textusd}>
                            USD
                        </Text>
                    </View>
                    <View>
                        <Text style={styles.total}>
                            {profile.walletAmount}
                        </Text>

                        <Text style={styles.reward}>
                            +  {profile.totalreward }
                        </Text>
                    </View>
                </View>

                <View style={{flexDirection : 'row' , justifyContent : 'space-around',alignItems : 'center' }}>





                    <TouchableOpacity style={styles.btn} onPress={()=>navigation.navigate('Withdraw')}>
                        <Text style={styles.btntext}>
                            Withdraw
                        </Text>
                        <MaterialCommunityIcons name="folder-upload" size={RFValue(24)} color="#FFF" />

                    </TouchableOpacity>

                    <TouchableOpacity style={styles.btn} onPress={()=>navigation.navigate('Deposit')}>
                        <Text style={styles.btntext}>
                            Deposit
                        </Text>


                        <MaterialCommunityIcons name="folder-download" size={RFValue(24)} color="#FFF" />



                    </TouchableOpacity>
                </View>




            </ImageBackground>
            <ScrollView style={{flex : 1 , backgroundColor : '#19222f'}}>
                <View style={styles.box2}>
                    {tab === 1 ?
                        <>

                            <View>
                                <View style={{flexDirection : 'row'}}>
                                    <Text style={styles.text3}>
                                        Deposits
                                    </Text>
                                    <Text onPress={()=>setTab(2)} style={styles.text33}>
                                        Withdraw
                                    </Text>
                                </View>
                            </View>

                            {deposits.length > 0 &&
                                <>
                                    {deposits.map( (item,index)=>

                                        <View key={index} style={styles.row}>
                                            <View style={styles.sectionrow}>
                                                <Text style={styles.textno}>{item.amount}</Text>
                                                <Text style={styles.textdate}>{item.currency}</Text>
                                            </View>
                                            <View style={styles.sectionrow}>
                                                <Text style={styles.textprice}>{item.amount_usd} usdt</Text>

                                                {item.stus === 'completed' ?
                                                    <Text style={styles.textstatus}>{item.stus}</Text>
                                                    :
                                                    <Text style={styles.textstatus2}>{item.stus}</Text>
                                                }
                                            </View>
                                        </View>

                                    )}
                                </>
                            }

                        </>
                        :
                        <>
                            <View>
                                <View style={{flexDirection : 'row'}}>
                                    <Text onPress={()=>setTab(1)} style={styles.text33}>
                                        Deposits
                                    </Text>
                                    <Text style={styles.text3}>
                                        Withdraw
                                    </Text>
                                </View>
                            </View>

                            {ws.length > 0 &&
                                <>
                                    {ws.map( (item,index)=>

                                        <View key={index} style={styles.row}>
                                            <View style={styles.sectionrow}>
                                                <Text style={styles.textno}>{item.packName}</Text>
                                                <Text style={styles.textdate}>{item.dateWithdraw}</Text>
                                            </View>
                                            <View style={styles.sectionrow}>
                                                <Text style={styles.textprice}>{item.amount} usdt</Text>
                                                {item.status == 200 ?
                                                    <Text style={styles.textstatus}>{item.statusText}</Text>
                                                    :
                                                    <Text style={styles.textstatus2}>{item.statusText}</Text>
                                                }

                                            </View>
                                        </View>

                                    )}
                                </>
                            }
                        </>




                    }






                </View>

            </ScrollView>
        </>


    );
}


const styles = StyleSheet.create({


    btn : {

        borderWidth : 1,
        borderColor : '#f6f6f6',
        width : '40%',
        marginTop : RFValue(45),


        flexDirection : 'row',
        justifyContent : "space-evenly",
        alignItems: 'center',
        paddingVertical : RFValue(3),
        borderRadius : RFValue(3),
        backgroundColor : 'transparent'


    },

    btntext : {
        color : '#f6f6f6',
        fontFamily : 'novaria',
    },


    bg2:{
        width : RFValue(50),
        marginHorizontal : RFValue(20),
        marginTop : RFValue(20),

        justifyContent : 'center',
        backgroundColor : 'transparent',
        padding : RFValue(6),
        borderRadius : RFValue(10),


    },

    total : {
        fontFamily : 'novaria',
        color : '#e1e1e1',

        fontSize : RFValue(40),
        paddingHorizontal : RFValue(20),
        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 3
    },
    reward : {
        fontFamily : 'novaria',
        color : '#fff900',
        fontSize : RFValue(15),
        paddingHorizontal : RFValue(20),
        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 3
    },

    textusd:{
        fontFamily : 'novaria',
        fontSize : RFValue(12),
        textAlign : 'center',
        color : '#FFF',
    },

    headertext : {
        fontFamily : 'novaria',
        fontSize : RFValue(20),
        padding : RFValue(20),
        color : '#FFF',
        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 3,
    },
    headername : {
        fontFamily : 'novaria',
        fontSize : RFValue(14),
        paddingHorizontal : RFValue(20),
        color : '#FFF',
        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 3,
    },
    icon :{
        backgroundColor : 'rgba(0,0,0,0.2)',
        padding : RFValue(6),
        borderRadius : RFValue(10),
        marginHorizontal : RFValue(20),
        marginTop : RFValue(11),
    },




    textstatus:{
        fontFamily : 'novaria',
        fontSize : RFValue(13),
        color : 'green',
        textAlign : 'right'
    },
    textstatus2:{
        fontFamily : 'novaria',
        fontSize : RFValue(13),
        color : '#ff6f00',
        textAlign : 'right'
    },
    textprice:{
        fontFamily : 'novaria',
        fontSize : RFValue(14),
        color : '#FFF',
        fontWeight : 'bold'
    },
    textno : {
        fontFamily : 'novaria',
        fontSize : RFValue(12),
        color : '#e1e1e1',

    },
    textdate : {
        fontFamily : 'novaria',
        fontSize : RFValue(10),
        color : '#d1d1d1',
    },

    row : {
      flexDirection:'row',
        justifyContent : "space-between",
        borderColor : '#444',
        borderBottomWidth : 1,
        padding : RFValue(5),
    },



    box2 : {
        margin : RFValue(10),
        backgroundColor : 'transparent',
        padding:RFValue(10),
        borderRadius : RFValue(3),
        borderColor : '#3a3a3b',
        borderWidth : 1,
        flex : 1,
        // flexDirection : 'row',
    },





    btn2 : {

        borderWidth : 1,
        borderColor : '#FFF',
        width : RFValue(120),
        justifyContent : "center",
        alignItems: 'center',
        padding : RFValue(5),
        borderRadius : RFValue(5),
        backgroundColor : '#ff6f00'


    },

    btntext2 : {
        color : '#FFF',
        fontFamily : 'novaria',
    },


    box : {
        margin : RFValue(10),
        backgroundColor : 'rgba(0,0,0,0.3)',
        padding:RFValue(10),
        borderRadius : RFValue(10),
        flexDirection : 'row',
    },

    text3 : {
        fontFamily : 'novaria',
        // color : '#FFF',
        // textAlign : 'center',
        fontSize : RFValue(17),
        padding : RFValue(10),
        // flex : 1,
        width : '50%',
        textAlign : "center",
        color : '#009688',
        textDecorationStyle : 'double',
        textDecorationLine : 'none',

    },
    text33 : {
        fontFamily : 'novaria',
        // color : '#FFF',
        // textAlign : 'center',
        fontSize : RFValue(17),
        padding : RFValue(10),
        // flex : 1,
        width : '50%',
        textAlign : "center",
        color : '#e1e1e1',


    },

    text1 : {
        fontFamily : 'novaria',
        color : '#FFF',
        // textAlign : 'center',
        fontSize : RFValue(17),
        padding : RFValue(10),
    },
    text2 : {
        fontFamily : 'novaria',
        color : '#FFF',
        textAlign : 'right',
        fontSize : RFValue(17),
        padding : RFValue(10),
    },

    section : {
      flex : 1
    },

    circule : {
        borderWidth : 1,
        borderColor : '#FFF',
        backgroundColor : 'rgba(0,0,0,0.4)',
        justifyContent : "center",
        alignItems : 'center',
        borderRadius : RFValue(110) / 2,
        padding : RFValue(5),
        height : RFValue(110),
        width : RFValue(110),
        marginTop : RFValue(15),
    },

    totalusdt : {
        fontFamily : 'novaria',
        color : '#FFF',
        textAlign : 'center',
        fontSize : RFValue(17),
        padding : RFValue(10),
        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: {width: -1, height: 1},
        textShadowRadius: 3
    },


















});


export default Wallet;
